module.exports = __webpack_public_path__ + "static/media/icebergCover.d04820bc.svg";